import { createForm, IFormProps } from '@formily/core'
import { FormProvider, createSchemaField, ISchema } from '@formily/vue'
import * as ImportComps from './bathImport'
import './style/theme.less'

/**
 * 参考文档
 * createForm：https://core.formilyjs.org/zh-CN/api/entry/create-form
 * schema：https://vue.formilyjs.org/api/shared/schema.html#schema
 * form实例：https://core.formilyjs.org/zh-CN/api/models/form
 */
interface IParams {
  schema: ISchema
  formProps?: IFormProps
  scope?: any
}

export function useFormilyForm<T extends object>({
  formProps = {},
  schema = {},
  scope = null,
}: IParams) {
  const form = createForm<T>(formProps)
  const submit = async (): Promise<T> =>
    new Promise<T>(async (resolve) => {
      let result: T | null = null
      try {
        result = await form.submit()
      } catch (error) {
        console.error('表单校验未通过', error)
      } finally {
        resolve(result!)
      }
    })
  // 注册所有用到的组件
  const { SchemaField } = createSchemaField({
    components: {
      ...ImportComps,
    },
    scope,
  })
  return {
    form,
    submit,
    FormilyForm: () => (
      <FormProvider form={form}>
        <SchemaField schema={schema} />
      </FormProvider>
    ),
  }
}
